'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _newStar3x = require('assets/img/account/newStar@3x.png');

var _newStar3x2 = _interopRequireDefault(_newStar3x);

var _newStarForAccount3x = require('assets/img/account/newStarForAccount@3x.png');

var _newStarForAccount3x2 = _interopRequireDefault(_newStarForAccount3x);

var _silverStar3x = require('assets/img/account/silverStar@3x.png');

var _silverStar3x2 = _interopRequireDefault(_silverStar3x);

var _silverStarForAccount3x = require('assets/img/account/silverStarForAccount@3x.png');

var _silverStarForAccount3x2 = _interopRequireDefault(_silverStarForAccount3x);

var _yellowStar3x = require('assets/img/account/yellowStar@3x.png');

var _yellowStar3x2 = _interopRequireDefault(_yellowStar3x);

var _yellowStarForAccount3x = require('assets/img/account/yellowStarForAccount@3x.png');

var _yellowStarForAccount3x2 = _interopRequireDefault(_yellowStarForAccount3x);

var _diamondStar3x = require('assets/img/account/diamondStar@3x.png');

var _diamondStar3x2 = _interopRequireDefault(_diamondStar3x);

var _diamondStarForAccount3x = require('assets/img/account/diamondStarForAccount@3x.png');

var _diamondStarForAccount3x2 = _interopRequireDefault(_diamondStarForAccount3x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Constant = {
  defaultAvatar: 'https://minio.lookme.vn/avatar/avatar/default-avatar.png',
  RANK: {
    new: {
      begin: '#F2F2F2',
      end: '#C4C4C4',
      label: 'Mới',
      color: '#E0E0E0',
      imageRank: _newStar3x2.default,
      memberStar: _newStarForAccount3x2.default,
      titleBenefit: '',
      benefit: [],
      no: 1
    },
    silver: {
      begin: '#C4C4C4',
      end: '#F8A831',
      label: 'Bạc',
      color: '#BDBDBD',
      imageRank: _silverStar3x2.default,
      memberStar: _silverStarForAccount3x2.default,
      titleBenefit: 'Đổi quà không ảnh hưởng đến việc thăng hạng của bạn',
      benefit: ['Một phần quà đặc biệt trong ngày sinh nhật', 'Đổi ưu đãi dành riêng cho Hạng Bạc'],
      unlock: true,
      no: 2
    },
    gold: {
      begin: '#F8A831',
      end: '#3D3736',
      label: 'Vàng',
      color: '#FFC95D',
      imageRank: _yellowStar3x2.default,
      memberStar: _yellowStarForAccount3x2.default,
      titleBenefit: 'Đổi quà không ảnh hưởng đến việc thăng hạng của bạn',
      benefit: ['Một phần quà đặc biệt trong ngày sinh nhật', 'Đổi ưu đãi dành riêng cho Hạng Vàng', 'Được tặng 1 phiếu massage miễn phí'],
      unlock: true,
      no: 3
    },
    diamond: {
      begin: '#F2F2F2',
      end: '#C4C4C4',
      label: 'Kim Cương',
      color: '#26BAB9',
      imageRank: _diamondStar3x2.default,
      memberStar: _diamondStarForAccount3x2.default,
      // color: 'rgba(61, 55, 54, 0.8)',
      titleBenefit: 'Đổi quà không ảnh hưởng đến việc thăng hạng của bạn',
      benefit: ['Một phần quà đặc biệt trong ngày sinh nhật', 'Đổi ưu đãi dành riêng cho Hạng Kim Cương', 'Được tặng 1 phiếu massage miễn phí', 'Miễn phí tư vấn stylist cá nhân 1 lần gồm phong cách, kiểu tóc và trang điểm'],
      unlock: true,
      no: 4
    }
  },
  BOOKING_STATUS: {
    pendingPayment: {
      status: 'pendingPayment',
      cancelable: true,
      message: 'Vui lòng thanh toán để chuyển qua bước tiếp theo',
      label: 'Đang thanh toán'
    },
    wait: {
      status: 'wait',
      cancelable: true,
      message: 'Lookme sẽ liên lạc với bạn để xác nhận dịch vụ',
      label: 'Đang chờ nhận'
    },
    acceptByMerchant: {
      status: 'accept',
      cancelable: true,
      message: 'Vui lòng đưa mã QR này cho nhân viên để sử dụng dịch vụ',
      label: 'Đã xác nhận'
    },
    acceptByLookme: {
      status: 'accept',
      cancelable: true,
      message: 'Vui lòng đưa mã QR này cho nhân viên để sử dụng dịch vụ',
      label: 'Lookme đã xác nhận'
    },
    processing: {
      status: 'accept',
      message: 'Đang sử dụng dịch vụ',
      label: 'Đang sử dụng'
    },
    paid: {
      status: 'accept',
      message: 'Đã thanh toán thành công.',
      label: 'Đã thanh toán'
    },
    complete: {
      status: 'accept',
      message: 'Lịch hẹn đã hoàn thành.',
      label: 'Hoàn tất'
    },
    notCome: {
      status: 'cancel',
      message: 'Bạn không đến sử dụng dịch vụ',
      label: 'Đã hủy',
      isReBooking: true
    },
    cancel: {
      status: 'cancel',
      message: 'Lịch đặt chỗ này của bạn đã hủy',
      label: 'Đã hủy',
      isReBooking: true
    }
  },
  ROUTE_CONFIGS: {
    Home: { logo: true, left: true, page: 'Home' },
    Category: { search: true, page: 'Category' },
    CollectionList: { title: 'Bộ Sưu Tập', back: true, page: 'CollectionList' },
    CollectionDetail: {
      logo: true,
      back: true,
      logoCenter: true,
      page: 'CollectionDetail'
    },
    History: { title: 'Lịch Sử', page: 'History' },
    Activity: { title: 'Hoạt Động', back: true, page: 'Activity' },
    Gift: { title: 'Điểm Thưởng & Voucher', back: true, page: 'Gift' },
    GiftDetail: {
      title: 'Điểm Thưởng & Voucher',
      back: true,
      page: 'GiftDetail'
    },
    Enterprise: { title: 'Ưu đãi đối tác', back: true, page: 'Enterprise' },
    Promotion: { title: 'Ưu Đãi', back: true, page: 'Promotion' },
    PromotionAtHome: {
      title: 'Ưu Đãi Tại Nhà',
      back: true,
      page: 'PromotionAtHome',
      homeOff: true,
      atHome: true
    },
    PromotionAtSpa: {
      title: 'Ưu Đãi Tại Spa',
      back: true,
      page: 'PromotionAtSpa',
      homeOff: true,
      atSpa: true
    },
    PromotionNoStar: {
      title: 'Ưu Đãi Trải Nghiệm',
      back: true,
      page: 'PromotionNoStar'
    },
    PromotionFiveStar: {
      title: 'Ưu Đãi 5 sao',
      back: true,
      page: 'PromotionFiveStar'
    },
    MyPromotion: {
      title: 'Ưu Đãi Của Tôi',
      back: true,
      page: 'MyPromotion'
    },
    ManagePromotion: {
      title: 'Quản lý ưu đãi',
      back: true,
      page: 'ManagePromotion'
    },
    MembershipBenefit: { back: true, title: 'Quyền lợi thành viên' },
    ExchangeReward: {
      logo: true,
      back: true,
      logoCenter: true,
      page: 'ExchangeReward'
    },
    BookingReward: {
      logo: true,
      back: true,
      logoCenter: true,
      page: 'BookingReward'
    },
    DetailBannerInfo: {
      logo: true,
      back: true,
      logoCenter: true,
      page: 'DetailBannerInfo'
    },
    CampaignPartner: {
      logo: true,
      back: true,
      logoCenter: true,
      page: 'CampaignPartner'
    },
    ServiceByCampaignDetail: {
      logo: false,
      back: true,
      logoCenter: true,
      page: 'ServiceByCampaignDetail'
    },
    VoucherFilter01: {
      back: true,
      page: 'VoucherFilter',
      title: 'Chăm sóc da / Massage'
    },
    VoucherFilter02: {
      back: true,
      page: 'VoucherFilter',
      title: 'Làm tóc / móng'
    },
    VoucherFilter03: {
      back: true,
      page: 'VoucherFilter',
      title: 'Thẩm mỹ viện'
    },
    VoucherFilter04: { back: true, page: 'VoucherFilter', title: 'Phòng khám' },
    VoucherFilter05: {
      back: true,
      page: 'VoucherFilter',
      title: 'Thể dục thể thao'
    },
    VoucherFilter06: { back: true, page: 'VoucherFilter', title: 'Xăm hình' },
    VoucherFilter07: {
      back: true,
      page: 'VoucherFilter',
      title: 'Dịch vụ tại nhà'
    },
    BookingOne: {
      logo: true,
      back: true,
      logoCenter: true,
      cancel: true,
      screen: 1,
      page: 'BookingOne'
    },
    BookingTwo: {
      logo: true,
      back: true,
      logoCenter: true,
      cancel: true,
      screen: 2,
      page: 'BookingTwo'
    },
    BookingThree: {
      logo: true,
      back: true,
      logoCenter: true,
      cancel: true,
      screen: 3,
      page: 'BookingThree'
    },
    ShopDetail: {
      logo: true,
      back: true,
      logoCenter: true,
      page: 'ShopDetail'
    },
    MoreInfoShopDetail: { back: true, title: 'Thông tin chi tiết' },
    Notification: { title: 'Thông báo', page: 'Notification', readAll: true },
    ManageBookingTab: { title: 'Lịch hẹn', back: false },
    ManageBooking: { title: 'Lịch hẹn', back: true },
    BookingRequestDetail: {
      logo: true,
      back: true,
      onBack: true,
      logoCenter: true
    },
    NewReview: { logo: true, back: true, logoCenter: true },
    ShopReview: { back: true, title: 'Đánh giá và xếp hạng' },
    PolicyMobile: { back: true, logo: true, logoCenter: true },
    PolicyMobile1: { back: true, title: 'Thông tin liên hệ' },
    PolicyMobile2: { back: true, title: 'Quy chế hoạt động' },
    PolicyMobile3: { back: true, title: 'Giải quyết tranh chấp' },
    PolicyMobile4: { back: true, title: 'Chính sách bảo mật' },
    Profile: { back: true, title: 'Thông tin cá nhân' },
    Feedback: { back: true, title: 'Góp Ý' },
    // Payment
    PaymentHistory: { back: true, title: 'Lịch sử nạp tiền' },
    PaymentList: { back: true, title: 'Phương thức thanh toán' },
    // End Payment
    GeneralCampaignList: { back: false, title: 'Ưu Đãi Bạn Bè' },
    // Home Service
    ServiceAtHome: { back: true, title: 'Dịch Vụ Tại Nhà' },
    ServiceDetail: { back: true, title: 'Chi Tiết Dịch Vụ' },
    default: { logo: true, logoCenter: true }
  },
  MODAL_CUSTOM: {
    EXCHANGE_REWARD_SUCCESS: {
      title: { text: 'Đổi Thành Công', type: 'success' },
      message: [{
        text: 'Kiểm tra danh sách ưu đãi của bạn, để sử dụng ưu đãi này.',
        type: 'note'
      }],
      button: 'EXCHANGE_REWARD_SUCCESS'
    },
    EXCHANGE_REWARD_FAIL: {
      title: { text: 'Lỗi', type: 'error' },
      message: [],
      button: 'EXCHANGE_REWARD_FAIL'
    },
    REWARD_EXISTED: {
      title: { text: 'Voucher đã được đổi', type: 'success' },
      message: [{
        text: 'Bạn đã đổi voucher này trước đó. Xem thông tin chi tiết?'
      }],
      button: 'REWARD_EXISTED'
    },
    CONFIRM_EXCHANGE_REWARD: {
      title: { text: 'Thông Báo', type: 'success' },
      message: [{ text: 'Bạn có chắc chắn muốn đổi ưu đãi này?' }],
      button: 'CONFIRM_EXCHANGE_REWARD'
    },
    REQUIRE_LOGIN: {
      title: { text: 'Thông Báo', type: 'success' },
      message: [{ text: 'Bạn cần đăng nhập để sử dụng tính năng này.' }],
      button: 'REQUIRE_LOGIN'
    },
    REQUIRE_EXCHANGE_SHOP: {
      title: { text: 'Thông Báo', type: 'warn' },
      message: [{ text: 'Bạn cần chọn chi nhánh trước khi sử dụng khuyến mãi.' }],
      button: 'REQUIRE_EXCHANGE_SHOP'
    },
    REWARD_FOR_APP: {
      title: { text: 'Thông báo', type: 'warn' },
      message: [{
        text: 'Ưu đãi này dành riêng cho app. Bạn cần tải app để sử dụng ưu đãi này.'
      }],
      button: 'REWARD_FOR_APP'
    },
    CATEGORY_SERVICE_FOR_APP: {
      title: { text: 'Thông báo', type: 'warn' },
      message: [{
        text: 'Loại dịch vụ chỉ sử dụng cho app. Bạn cần tải app để sử dụng ưu đãi của dịch vụ này.'
      }],
      button: 'CATEGORY_SERVICE_FOR_APP'
    }
  },
  DAY_OF_WEEK: {
    Mon: 'Monday',
    Tue: 'Tuesday',
    Wed: 'Wednesday',
    Thu: 'Thursday',
    Fri: 'Friday',
    Sat: 'Saturday',
    Sun: 'Sunday'
  },
  TYPE_LOCAL_BUSINESS: {
    'cham-soc-da-massage': 'DaySpa',
    'lam-toc-mong': 'HairSalon',
    'tham-my-vien': 'BeautySalon',
    'phong-kham': 'HealthClub',
    'the-duc-the-thao': 'HealthClub',
    'xam-hinh': 'TattooParlor'
  },
  // TrackingButton
  TRACKING_ROUTE: {
    '/': { screen: 'Home' },
    'dang-nhap': {},
    'kham-pha': { screen: 'Search' },
    'cham-soc-da-massage': {},
    'lam-toc-mong': {},
    'tham-my-vien': {},
    'phong-kham': {},
    'the-duc-the-thao': {},
    'xam-hinh': {},
    'salon-mi-va-mong': {},
    'spa-cham-da': {},
    'massage-va-goi-dau': {},
    'tham-my-va-nha-khoa': {},
    'salon-toc-va-make-up': {},
    'dich-vu-tai-nha': {},
    uudai: {},
    'uu-dai': {},
    'uu-dai-tai-nha': {},
    'uu-dai-tai-spa': {},
    'uu-dai-trai-nghiem': {},
    'uu-dai-5-sao': {},
    'uu-dai-toi': {},
    'uu-dai-goi/:campaignHandle': {},
    'voucher-detail/:voucherId': {},
    'uu-dai-cham-soc-da-massage': {},
    'uu-dai-lam-toc-mong': {},
    'uu-dai-tham-my-vien': {},
    'uu-dai-phong-kham': {},
    'uu-dai-the-duc-the-thao': {},
    'uu-dai-xam-hinh': {},
    'uu-dai-dich-vu-tai-nha': {},
    'uu-dai/:handle': {},
    'uu-dai-doi-tac': {},
    'huong-dan-doi-tac': {},
    'kol/:code': {},
    'uu-dai-cua-toi/:code': {},
    'chinh-sach': {},
    'thong-tin-lien-he': {},
    'quy-che-hoat-dong': {},
    'giai-quyet-tranh-chap': {},
    'bao-mat': {},
    ':query': {},
    'dat-lich': { screen: 'Booking' },
    'dat-lich-2': { screen: 'Step Two' },
    'dat-lich-3': { screen: 'Step Three' },
    'lich-hen': { screen: 'ManageBooking' },
    'quan-ly-dat-cho': {},
    'lich-hen/:bookingRequestId': {},
    'tai-khoan': { screen: 'Account' },
    'lich-su-hoat-dong': {},
    history: {},
    'chinh-sua-tai-khoan': {},
    'quan-ly-uu-dai': {},
    'thong-bao': { screen: 'Notification' },
    'gop-y': {},
    'quyen-loi-thanh-vien': {},
    'lich-su-nap-tien': {},
    'phuong-thuc-thanh-toan': {},
    '/bo-suu-tap': {},
    '/bo-suu-tap/:handle': {},
    'khuyen-mai/:id': {},
    ':shopHandle/viet-danh-gia': {},
    'tao-cua-hang': {},
    'chat/:shopHandle': {},
    ':shopHandle/danh-gia': {},
    'shop/:id': {},
    ':id': {},
    'dich-vu/:handle': {},
    'thong-tin-shop/:id': {}
  }
};
exports.default = Constant;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Constant.js
// module id = 55
// module chunks = 0